import React, { useEffect, useRef } from "react";
import notebook from "../../../assets/images/computadora.png";
import WhatsAppLogo from "../../../assets/images/wpp-logo.png";
import MessengerLogo from "../../../assets/images/mss-png.png";

const ComputerWithLogo = () => {
    const containerRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        const container = containerRef.current;
        const image = imageRef.current;

        const handleMouseMove = (e) => {
            const { left, top, width, height } = container.getBoundingClientRect();
            const x = e.clientX - left - width / 2;
            const y = e.clientY - top - height / 2;

            const rotateX = (y / height) * 20;
            const rotateY = (x / width) * -20;

            image.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
        };

        const handleMouseLeave = () => {
            image.style.transform = `rotateX(0deg) rotateY(0deg)`;
        };

        container.addEventListener('mousemove', handleMouseMove);
        container.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            container.removeEventListener('mousemove', handleMouseMove);
            container.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);

    return (
        <div className="container-img__computer" ref={containerRef}>
{/*             <img src={WhatsAppLogo} className="wpp-logo__img" alt="WhatsApp Logo" />
            <img src={MessengerLogo} className="mss-logo__img" alt="Messenger Logo" /> */}
            <img src={notebook} className="computer-img" ref={imageRef} alt="Computer" />
        </div>
    );
};

export default ComputerWithLogo;
